var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { st, classes } from './TabsNavButton.st.css';
import { isSelectKey } from '../../../common/keyCodes';
var TabsNavButton = /** @class */ (function (_super) {
    __extends(TabsNavButton, _super);
    function TabsNavButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onKeyDown = function (e) {
            var onClick = _this.props.onClick;
            if (isSelectKey(e)) {
                onClick();
                return false;
            }
            return undefined;
        };
        _this._rootRefCallback = function (el) {
            _this._rootRef = el;
        };
        return _this;
    }
    TabsNavButton.prototype.width = function () {
        return this._rootRef ? this._rootRef.offsetWidth : 0;
    };
    TabsNavButton.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, children = _a.children, tabIndex = _a.tabIndex, className = _a.className;
        return (React.createElement("div", { className: st(classes.root, className), onClick: onClick, onKeyDown: this._onKeyDown, tabIndex: tabIndex, "data-hook": this.props['data-hook'], ref: this._rootRefCallback },
            children,
            React.createElement("div", { className: classes.border })));
    };
    return TabsNavButton;
}(React.Component));
export { TabsNavButton };
//# sourceMappingURL=TabsNavButton.js.map